import { ArticleState } from 'mk2/apps/wiki/containers/Article/Article.reducers';
import { LoadingState } from 'mk2/reducers/loadingState';

export const WIKI_MENU_MORE = 'wiki-more';

export const initialArticleState: ArticleState = {
    articleId: null,
    loadingState: LoadingState.INIT,
    errorMessage: null,
    feedbackSubmitted: false,
};
